<template>
  <loading v-if="loading && !loaded" />
  <div v-else-if="loadOnInit && !list.length"></div>
  <div class="dropdown pb-3" v-else>
    <DropdownButton
      :id="itemId(selectedValue)"
      :label="`Select ${field}...`"
      @remove="$emit('chooseItem', {})"
      @click="loadData"
    >
      <template v-slot:menu>
        <ul
          class="dropdown-menu w-100"
          role="menu"
          :aria-labelledby="`submenu-${itemId(selectedValue)}`"
          style="max-height: 400px; overflow-y: scroll"
          v-if="allData"
        >
          <li
            role="presentation"
            v-for="(item, index) in allData"
            :key="`${itemId(item)}-${index}`"
            class="d-flex justify-content-between cursor-pointer p-3 border-bottom"
            @click="$emit('chooseItem', item)"
          >
            <div class="w-100 d-flex align-items-start">
              <h6 class="m-0">{{ itemName(item) }}</h6>
            </div>
          </li>
          <li class="d-flex justify-content-between cursor-pointer p-2 border-bottom" v-if="loading">
            <loading />
          </li>
        </ul>
        <div v-else class="text-muted">No locations found</div>
      </template>
    </DropdownButton>
  </div>
</template>

<script>
export default {
  props: ['data', 'value', 'field', 'product', 'loadOnInit'],
  computed: {
    allData() {
      return [...this.data, ...this.list];
    },
    selectedValue() {
      if (this.value.isNone || !(this.itemId(this.value) || this.itemName(this.value))) {
        return { name: `Select ${this.field}`, [`${this.field}_id`]: -1 };
      }
      return (
        this.data.find(
          (e) =>
            e[`${this.field}Name`] !== 'NONE' &&
            (this.itemName(e) === this.itemName(this.value) || this.itemId(e) === this.itemId(this.value))
        ) || {}
      );
    }
  },
  data() {
    return {
      list: [],
      loaded: false,
      loading: false
    };
  },
  mounted() {
    if (this.loadOnInit) {
      this.loadData();
    }
  },
  methods: {
    async loadData() {
      try {
        if (this.loaded || this.loading) return;
        this.loading = true;
        const data = (await this.$http.get(`/products/${this.product._id}/locations?limit=100`)).data;
        const exist = this.list.map((e) => this.itemId(e));
        if (this.field === 'decoration') {
          this.list.push(
            ...data.locations
              .filter((e) => !exist.includes(this.itemId(e)))
              .map((e) =>
                e.decorations
                  .filter((e) => !exist.includes(this.itemId(e)))
                  .map((d) => ({ ...d, label: [e.name, d.name].join(': ') }))
              )
              .reduce((a, b) => [...a, ...b], [])
          );
        } else {
          this.list.push(...data.locations.filter((e) => !exist.includes(this.itemId(e))));
        }

        this.loaded = true;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    itemId(item) {
      return item[`${this.field}_id`] || item[`${this.field}Id`];
    },
    itemName(item) {
      return item[`${this.field}_name`] || item[`${this.field}Name`] || item.label || item.name;
    }
  },
  components: {
    DropdownButton: () => import('@/components/DropdownButton')
  }
};
</script>
